import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGenius = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 40"
    {...props}
  >
    <path
      fill="#4B7EFF"
      fillRule="evenodd"
      d="M5.001 0H12c1.819 0 3.643 1.495 3.794 3.232l.646 6.845c.35 3.703 1.774 5.133 5.483 5.483l6.845.646c1.712.161 3.232 1.95 3.232 3.736V35c0 2.743-2.257 5-5 5H5c-2.745 0-5-2.25-5-5V5c0-2.75 2.25-5 5-5z"
      clipRule="evenodd"
    />
    <path
      fill="#292A33"
      fillRule="evenodd"
      d="M31.543 18.182c-2.801-1.003-11.675 1.184-13.564 1.635-3.621.866-5.738-1.424-5.05-5.116C13.304 12.691 15.258 3.9 14.17.91c.596.597 1.462.87 1.541 2.366l.646 6.36c.38 3.744 2.338 5.736 6.041 6.121l6.278.655c1.471.153 2.233 1.08 2.866 1.77"
      clipRule="evenodd"
      opacity={0.2}
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M18.055 25.302q-2.795.649-4.487 2.439-1.695 1.794-2.312 4.744a.29.29 0 0 1-.348.235.3.3 0 0 1-.22-.235q-.623-2.971-2.321-4.757-1.698-1.784-4.48-2.426a.31.31 0 0 1-.223-.367.3.3 0 0 1 .239-.24c1.858-.444 3.36-1.258 4.493-2.455 1.123-1.187 1.89-2.758 2.29-4.723a.293.293 0 0 1 .346-.238c.122.027.21.131.228.254.418 1.961 1.19 3.546 2.321 4.741 1.127 1.19 2.615 2.001 4.473 2.424a.31.31 0 0 1 .225.366.3.3 0 0 1-.224.238M27.298 31.524q-1.573.343-2.524 1.29-.952.95-1.3 2.513a.163.163 0 0 1-.195.123.16.16 0 0 1-.125-.123q-.349-1.575-1.304-2.519t-2.52-1.284a.164.164 0 0 1 .008-.322q1.57-.35 2.527-1.3.95-.941 1.288-2.5a.164.164 0 0 1 .323.009q.352 1.559 1.306 2.51.948.947 2.516 1.283a.163.163 0 0 1 0 .32M10.841 9.706q-1.572.344-2.524 1.292t-1.3 2.511a.164.164 0 0 1-.32 0q-.35-1.574-1.305-2.518-.955-.945-2.52-1.285a.163.163 0 0 1 .009-.321q1.57-.35 2.527-1.3.949-.941 1.288-2.5a.165.165 0 0 1 .323.008c.235 1.038.669 1.878 1.306 2.51q.948.947 2.516 1.283c.089.02.145.106.127.194a.17.17 0 0 1-.127.126"
      clipRule="evenodd"
    />
    <path
      fill="#DBE4F5"
      fillRule="evenodd"
      d="m15.101 3.241.652 7.429c.326 3.718 1.785 5.175 5.526 5.499l7.464.648.14.014c.906.109 1.721.514 2.289 1.124A3.04 3.04 0 0 1 32 20v-.317C32 14.774 17.153 0 12.223 0h-.337c.853.01 1.594.35 2.149.897.6.592.986 1.426 1.067 2.344"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgGenius;
